// event.key wasn't working in IE11 so I set up this const object instead for
// event.which key codes
export default {
	LEFT: 37,
	UP: 38,
	RIGHT: 39,
	DOWN: 40,
	TAB: 9,
	ESC: 27,
	ENTER: 13,
	SHIFT: 16,
	SPACE: 32
};
